__turbopack_context__.v({
  "contentLeft": "waitlist-client-module__ID88Lq__contentLeft",
  "desktopAnnotations": "waitlist-client-module__ID88Lq__desktopAnnotations",
  "desktopImage": "waitlist-client-module__ID88Lq__desktopImage",
  "heroHeading": "waitlist-client-module__ID88Lq__heroHeading",
  "heroSection": "waitlist-client-module__ID88Lq__heroSection",
  "imageRight": "waitlist-client-module__ID88Lq__imageRight",
  "mobileAnnotations": "waitlist-client-module__ID88Lq__mobileAnnotations",
  "mobileImage": "waitlist-client-module__ID88Lq__mobileImage",
  "waitlistCTA": "waitlist-client-module__ID88Lq__waitlistCTA",
});
